import * as React from "react";
import { amountToCurrencyString } from "types/amount";
import { IAmount } from "types/fee";

/**
 * Component for displaying a formatted currency value
 * @param props 
 */
export const FormattedAmount = (props: {
    amount?: IAmount;
    big?: boolean;
}) => {
    if (props.amount) {
        if (props.big === true) {
            return <p className="theme-title-color" style={{ fontSize: 32, margin: 0, padding: 0 }}>{amountToCurrencyString(props.amount)}</p>;
        } else {
            return <span>{amountToCurrencyString(props.amount)}</span>;
        }
    } else {
        return null;
    }
};



// WEBPACK FOOTER //
// ./src/components/util/FormattedAmount.tsx